import { render, staticRenderFns } from "./BuffetPriceDishFragment.vue?vue&type=template&id=2ab191cc&scoped=true"
import script from "./BuffetPriceDishFragment.vue?vue&type=script&lang=js"
export * from "./BuffetPriceDishFragment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab191cc",
  null
  
)

export default component.exports